module.exports = __webpack_public_path__ + "57788db6a675dc5d0441864976a60a6b.png";